import styled from 'styled-components'

export const VoiceSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const SpeakerRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: stretch;

  /* the speaker dropdown grows, the speed control keeps its intrinsic width */
  & > *:first-child {
    flex: 1;
    min-width: 0;
  }
`
